// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjetosDestaque_secao__vmOK4 {
  padding: 6rem 1.5rem;
  max-width: 1100px;
  margin: 0 auto;
}

.ProjetosDestaque_etiqueta__NUi9a {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: hsl(217, 91%, 60%);
  margin-bottom: 1rem;
  display: block;
  text-align: center;
}

.ProjetosDestaque_titulo__ceSgP {
  font-size: 2.5rem;
  font-weight: 800;
  color: hsl(210, 40%, 95%);
  margin-bottom: 3rem;
  text-align: center;
}

.ProjetosDestaque_listaProjetos__heaU8 {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.ProjetosDestaque_card__9gLK\\+ {
  background: hsl(222, 44%, 9%);
  border: 1px solid hsl(222, 30%, 18%);
  border-radius: 1rem;
  padding: 2rem;
  transition: all 0.3s ease;
}

.ProjetosDestaque_card__9gLK\\+:hover {
  border-color: hsl(217, 91%, 60%, 0.3);
  box-shadow: 0 0 40px hsl(217, 91%, 60%, 0.08);
}

.ProjetosDestaque_cardCabecalho__D0asN {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.ProjetosDestaque_emoji__cmpZv {
  font-size: 1.5rem;
}

.ProjetosDestaque_cardTitulo__mW-80 {
  font-size: 1.4rem;
  font-weight: 700;
  color: hsl(210, 40%, 95%);
}

.ProjetosDestaque_cardDescricao__yxCoO {
  color: hsl(215, 20%, 55%);
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 1.25rem;
}

.ProjetosDestaque_secaoInterna__UDont {
  margin-bottom: 1.25rem;
}

.ProjetosDestaque_secaoInternaTitulo__CkPYR {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  color: hsl(217, 91%, 60%);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 0.75rem;
}

.ProjetosDestaque_tecnologias__bWQ9a {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.ProjetosDestaque_tecnologia__URHHt {
  font-size: 0.8rem;
  color: hsl(215, 20%, 65%);
  background: hsl(222, 30%, 14%);
  padding: 0.35rem 0.75rem;
  border-radius: 0.4rem;
}

.ProjetosDestaque_desafios__A-cpX {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.ProjetosDestaque_desafio__xbJKs {
  color: hsl(215, 20%, 55%);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ProjetosDestaque_desafio__xbJKs::before {
  content: '▸';
  color: hsl(217, 91%, 60%);
  font-size: 0.75rem;
}

.ProjetosDestaque_cardRodape__8m6mR {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid hsl(222, 30%, 18%);
}

.ProjetosDestaque_botaoVer__oposT {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: hsl(217, 91%, 60%);
  background: none;
  border: 1px solid hsl(217, 91%, 60%, 0.3);
  padding: 0.6rem 1.25rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.ProjetosDestaque_botaoVer__oposT:hover {
  background: hsl(217, 91%, 60%, 0.1);
  border-color: hsl(217, 91%, 60%);
}
`, "",{"version":3,"sources":["webpack://./src/components/ProjetosDestaque/ProjetosDestaque.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC","sourcesContent":[".secao {\n  padding: 6rem 1.5rem;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.etiqueta {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  color: hsl(217, 91%, 60%);\n  margin-bottom: 1rem;\n  display: block;\n  text-align: center;\n}\n\n.titulo {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: hsl(210, 40%, 95%);\n  margin-bottom: 3rem;\n  text-align: center;\n}\n\n.listaProjetos {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.card {\n  background: hsl(222, 44%, 9%);\n  border: 1px solid hsl(222, 30%, 18%);\n  border-radius: 1rem;\n  padding: 2rem;\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  border-color: hsl(217, 91%, 60%, 0.3);\n  box-shadow: 0 0 40px hsl(217, 91%, 60%, 0.08);\n}\n\n.cardCabecalho {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.emoji {\n  font-size: 1.5rem;\n}\n\n.cardTitulo {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: hsl(210, 40%, 95%);\n}\n\n.cardDescricao {\n  color: hsl(215, 20%, 55%);\n  font-size: 0.95rem;\n  line-height: 1.7;\n  margin-bottom: 1.25rem;\n}\n\n.secaoInterna {\n  margin-bottom: 1.25rem;\n}\n\n.secaoInternaTitulo {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.75rem;\n  color: hsl(217, 91%, 60%);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-bottom: 0.75rem;\n}\n\n.tecnologias {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.tecnologia {\n  font-size: 0.8rem;\n  color: hsl(215, 20%, 65%);\n  background: hsl(222, 30%, 14%);\n  padding: 0.35rem 0.75rem;\n  border-radius: 0.4rem;\n}\n\n.desafios {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.desafio {\n  color: hsl(215, 20%, 55%);\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.desafio::before {\n  content: '▸';\n  color: hsl(217, 91%, 60%);\n  font-size: 0.75rem;\n}\n\n.cardRodape {\n  margin-top: 1.5rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid hsl(222, 30%, 18%);\n}\n\n.botaoVer {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: hsl(217, 91%, 60%);\n  background: none;\n  border: 1px solid hsl(217, 91%, 60%, 0.3);\n  padding: 0.6rem 1.25rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n\n.botaoVer:hover {\n  background: hsl(217, 91%, 60%, 0.1);\n  border-color: hsl(217, 91%, 60%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secao": `ProjetosDestaque_secao__vmOK4`,
	"etiqueta": `ProjetosDestaque_etiqueta__NUi9a`,
	"titulo": `ProjetosDestaque_titulo__ceSgP`,
	"listaProjetos": `ProjetosDestaque_listaProjetos__heaU8`,
	"card": `ProjetosDestaque_card__9gLK+`,
	"cardCabecalho": `ProjetosDestaque_cardCabecalho__D0asN`,
	"emoji": `ProjetosDestaque_emoji__cmpZv`,
	"cardTitulo": `ProjetosDestaque_cardTitulo__mW-80`,
	"cardDescricao": `ProjetosDestaque_cardDescricao__yxCoO`,
	"secaoInterna": `ProjetosDestaque_secaoInterna__UDont`,
	"secaoInternaTitulo": `ProjetosDestaque_secaoInternaTitulo__CkPYR`,
	"tecnologias": `ProjetosDestaque_tecnologias__bWQ9a`,
	"tecnologia": `ProjetosDestaque_tecnologia__URHHt`,
	"desafios": `ProjetosDestaque_desafios__A-cpX`,
	"desafio": `ProjetosDestaque_desafio__xbJKs`,
	"cardRodape": `ProjetosDestaque_cardRodape__8m6mR`,
	"botaoVer": `ProjetosDestaque_botaoVer__oposT`
};
export default ___CSS_LOADER_EXPORT___;
